module.exports = __webpack_public_path__ + "img/fuzeicon.b878fa65.png";